import css from './DropdownDivider.module.css'

const DropdownDivider = () => {
    return <div className={css.divider} />
}

export default DropdownDivider
